import styled from 'styled-components';

const Header = styled.h1`
  margin: 0;
  padding: 0;
  line-height: 48px;
  font-size: 36px;
  color: #000;
  font-weight: bold;
  font-family: ${props => props.theme.fonts.regular};
`;

export default Header;



// WEBPACK FOOTER //
// ./src/components/units/Header/Header.js